<template>
    <main class="cms-template app__main">
        <div class="cms-container container">
            <slot name="cms-content"></slot>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'CmsTemplate',

        components: {

        },

        props: {
        },
    };
</script>

<style lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_placeholders';
    @import '~@/assets/styles/abstracts/_mixins';

    .cms-template {
        padding-top : 15rem;
    }
</style>
